'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'

import '../_style/jobs-clinic-swiper.css'

const AJobsSectionClinic = () => {
	const t = useTranslations('pages.letsMakeWorldHealthier.clinic')
	const cdn = process.env.NEXT_PUBLIC_CDN_URL ?? ''

	const images = [
		{
			src: `${cdn}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-1.avif`,
			alt: 'Recepcia Polikliniky Medante'
		},
		{
			src: `${cdn}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-2.avif`,
			alt: 'Ambulancia Polikliniky Medante'
		},
		{
			src: `${cdn}/assets/images/gallery/gallery-v2-poliklinika-medante-priestory-5.avif`,
			alt: 'Recepcia Polikliniky Medante 2'
		}
	]

	const clinicImageBody = (image: (typeof images)[number]) => (
		<div className='relative w-full overflow-hidden rounded-3xl bg-m-sand-2/40 aspect-video md:aspect-auto md:h-[240px]'>
			<Image
				src={image.src}
				alt={image.alt}
				fill
				className='object-cover'
				sizes='(max-width: 1023px) 85vw, 34vw'
				unoptimized
			/>
		</div>
	)

	return (
		<section className='overflow-x-visible pb-12 lg:pb-20 lg:-mt-24'>
			<div>
				<div className='wrapper2 flex flex-col justify-center'>
					<h2 className='type-medante-h1'>{t('title')}</h2>
					<div className='page_content reset_margins nobalance mt-4'>
						<p>
							{t.rich('text', {
								br: () => <br />
							})}
						</p>
					</div>
				</div>

				<div className='mt-6 w-full'>
					<div className='w-full min-w-0'>
						{/* Mobile: Swiper 16:9, ~1.2 slides, peek; desktop: static row */}
						<div className='md:hidden w-full min-w-0'>
							<Swiper
								modules={[A11y]}
								className='jobs-clinic-swiper w-full max-w-full'
								speed={480}
								grabCursor
								centeredSlides
								centeredSlidesBounds
								slidesPerView={1.2}
								spaceBetween={12}
							>
								{images.map((image, index) => (
									<SwiperSlide key={`${image.src}-${index}`} className='h-auto'>
										{clinicImageBody(image)}
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						<div className='hidden md:grid md:grid-cols-[37fr_26fr_37fr] md:gap-4 wrapper2'>
							{images.map((image, index) => (
								<div key={`${image.src}-${index}`} className='min-w-0'>
									{clinicImageBody(image)}
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default AJobsSectionClinic
